import { Injectable } from '@angular/core';
import { SeatingDetailStore } from './seating-detail.store';
import { SeatingDetail } from './seating-detail.model';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { MemberQuery } from '../member/member.query';

@Injectable({ providedIn: 'root' })
export class SeatingDetailService {
  constructor(private seatingDetailsStore: SeatingDetailStore, private api: ApiService, private memberQuery: MemberQuery) {}

  fetchSeatingDetails() {
    const user = this.memberQuery.getUserContext();

    return this.api.getAnySingle<SeatingDetail>(`members/${user.memberId}/seating`).pipe(
      tap(seatingDetails => this.seatingDetailsStore.set([seatingDetails])),
      mapTo(null)
    );
  }
}
